import type { IconData } from '@stacksjs/iconify-core'

export const basicUiUnlink: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14.047 11.38A6.667 6.667 0 1 0 4.62 1.954l-.833.833L1 0L0 1l15 15l1-1l-2.786-2.786zM7.303 4.819l-.742.743l1.06 1.06l.743-.742a1.243 1.243 0 0 1 1.757 1.757l-.742.743l1.06 1.06l.743-.742a2.743 2.743 0 1 0-3.879-3.879\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M11.211 14.211A6.667 6.667 0 0 1 1.79 4.79l2.789 2.789a2.743 2.743 0 0 0 3.844 3.844z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiUnlink
